import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/Requests/axios";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import { size } from "lodash";

function ForgotPassword() {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);
  const [username, setUsername] = useState("");
  const [errors, setErrors] = useState({});
  const [validate, setValidate] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!/\S+@\S+\.\S+/.test(username)) {
      newErrors.email = "Please enter a valid email address.";
    }
    return newErrors;
  };

  useEffect(() => {
    const validationErrors = validateForm();
    setErrors(validationErrors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username]);

  const handleForgetPassword = (e) => {
    e.preventDefault();
    setValidate(true);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    axiosInstance
      .post("/auth/reset-password", { username })
      .then(() => {
        // Handle success logic (e.g., redirect, show a message)
        setSubmitted(true);
      })
      .catch((error) => {
        console.error("Error occured in sending forgot password request:", error);
        // Handle error logic (e.g., show error message)
      });
  };

  return (
    <div
      className="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1"
      style={{ maxWidth: "25rem" }}
      onSubmit={handleForgetPassword}
    >
      <form className="js-validate needs-validation" novalidate="">
        <div className="text-center">
          <div className="mb-5">
            <h1 className="display-5">{t("Forgot password?")}</h1>
            {
              submitted && !size(errors) ? (
                <p>
                  {t(
                    "If an account exists for provided email address, you will get an email with instructions on resetting your password. If it doesn't arrive, be sure to check your spam folder."
                  )}
                </p>
              ) : (
                <p>
                  {t(
                    "Enter the email address you used when you joined and we'll send you instructions to reset your password."
                  )}
                </p>
              )
            }
          </div>
        </div>

        {
          submitted && !size(errors) ? '' : (
            <div className="mb-4">
              <label
                className="form-label"
                htmlFor="resetPasswordSrEmail"
                tabIndex="0"
              >
                {t("Your email")}
              </label>

              <input
                type="email"
                className={`form-control form-control-lg ${
                  validate && errors.email
                    ? "is-invalid"
                    : validate && username
                    ? "is-valid"
                    : ""
                }`}
                name="email"
                id="resetPasswordSrEmail"
                tabIndex="1"
                placeholder="Enter your email address"
                aria-label="Enter your email address"
                required=""
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              {validate && errors.email && (
                <span className="invalid-feedback">
                  {t(errors.email)}
                </span>
              )}
            </div>
          )
        }

        <div className="d-grid gap-2">
          {
            submitted && !size(errors) ? '' : (
              <button type="submit" className="btn btn-primary btn-lg">
                {t("Submit")}
              </button>
            )
          }

          <div className="text-center">
            <button
              className="btn btn-link"
              onClick={() => navigate("/sign-in")}
            >
              <i className="bi-chevron-left"></i> {t("Back to Sign in")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;
